import { render, staticRenderFns } from "./Lobby.vue?vue&type=template&id=c0f8ff3a&"
import script from "./Lobby.vue?vue&type=script&lang=js&"
export * from "./Lobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports